// Static data for demonstration - in future this will come from API
export const staticCommitteeData = {
	applicationId: "658547",
	instituteName: "Govt College of Technology Gujranwala",
	instituteId: "12345",
	committeeId: "COM001",
	inspectionDate: "2024-01-15",
	inspectionTime: "10:00 AM",
	createdBy: "Admin User",
	createdOn: "2024-01-10",
	verifiedBy: "Verifier User",
	verifiedOn: "2024-01-12",
	editCount: 2,
	committeeType: "Technical",
	members: [
		{
			id: "1",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Convener" as const,
			profileImage: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150&h=150&fit=crop&crop=face",
		},
		{
			id: "2",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Member" as const,
		},
		{
			id: "3",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Member" as const,
		},
		{
			id: "4",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Member" as const,
		},
		{
			id: "5",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Member" as const,
		},
		{
			id: "6",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Member" as const,
		},
		{
			id: "7",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Member" as const,
		},
		{
			id: "8",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Member" as const,
		},
		{
			id: "9",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Member" as const,
		},
		{
			id: "10",
			name: "Ajmal Saeed",
			firstName: "Ajmal",
			lastName: "Saeed",
			grade: "18+",
			experience: "5 Years",
			technology: "Computer",
			assignedCourses: "Computer",
			role: "Member" as const,
		},
	],
};
